module.exports = __webpack_public_path__ + "img/sign.47d60baf.jpeg";